import React from "react";
import styles from "./FlipButton.module.css";

const FlipButton = ({ setIsFlipped }) => {
  const handleFlip = (e) => {
    e.preventDefault();
    setIsFlipped((prev) => !prev);
  };
  return (
    <button className={styles.flipBtn} onClick={handleFlip}>
      <span className={styles.flipIcon}></span>
    </button>
  );
};

export default FlipButton;
